<button class="button _secondary"
        [class.expanded]="expanded"
        [disabled]="disabled || loading">
    <a-button-text [labelKey]="labelKey" [loading]="loading"></a-button-text>
</button>
